import { alpha, styled, TabProps } from '@mui/material';
import Tab, { tabClasses } from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

type StyledTabProps = TabProps & {
  label: string;
  value: string;
  selected?: boolean;
};

export const StyledTab = styled(({ ...otherProps }: StyledTabProps) => (
  <Tab
    disableRipple
    {...otherProps}
  />
))(({ theme, selected }) => ({
  ...theme.typography.textSm,
  backgroundColor: 'none',
  border: 'none',
  color: theme.palette.text.secondary,
  position: selected ? 'relative' : 'static',
  zIndex: selected ? 1 : 0,
  [`&.${tabClasses.selected}`]: {
    color: 'inherit',
  },
  opacity: selected ? 1 : 0.5,
  marginInline: theme.spacing(1),
  padding: 0,
  height: theme.spacing(8),
  minHeight: theme.spacing(8),
  flexShrink: 1,
}));

export const StyledTabList = styled(Tabs)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.border.primary,
  minHeight: theme.spacing(8.75),
  height: theme.spacing(8.75),
  alignSelf: 'center',
  backgroundColor: alpha(theme.palette.common.black, 0.02),
  borderRadius: theme.shape.borderRadius * 2.5,
}));
